import { makeStyles, Theme } from '@material-ui/core';

type Props = {
  frameDetailsCount: number;
};

const useStyles = makeStyles((theme: Theme) => ({
  container: (props: Props) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${props.frameDetailsCount}, max-content)`,
    width: '100%',
    columnGap: theme.spacing(1.5),
  }),
}));

export default useStyles;
